import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";
import { IconButton } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Translate } from "@material-ui/icons";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "direction",
    type: "translate",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return (
    <ResourceListPage
      url="languages"
      columns={columns}
      actions={
        <IconButton component={Link} to={`/s/translations`}>
          <Translate />
        </IconButton>
      }
    />
  );
}
